(function () {
  if (window.duuDuuHundredNightTrialReady) return;

  window.duuDuuHundredNightTrialReady = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-hundred-night-trial-buy]');
    if (!trigger) return;

    var mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (!mainProduct) return;

    var stickyHeader = document.querySelector('.shopify-section-header-sticky, sticky-header');
    var headerHeight = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
    var targetTop = mainProduct.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });

    var addButton = mainProduct.querySelector('button[name="add"]:not([disabled])');
    if (!addButton) return;

    window.setTimeout(
      function () {
        addButton.focus({ preventScroll: true });
      },
      reduceMotion ? 0 : 550
    );
  });
})();
